import { Component } from 'react';
import Nano from 'nanobar';
import './NanoBar.scss';

class NanoBar extends Component {
  nanobar = null;

  componentDidMount() {
    this.nanobar = new Nano({
      className: 'nanobar',
      id: 'nanobar',
    });

    window.nanobar = this.nanobar;
  }

  remove = () => {
    window.nanobar = null;
    delete this.nanobar;
  };

  render() {
    return null;
  }
}

export default NanoBar;
